const setNewPasswordFormFields = {
  password: '',
  confirmPassword: '',
  otp: ''
};

export { setNewPasswordFormFields };
